<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
          <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title> <h3>{{get_dialogMain.title}}</h3> </v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN"> <v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <FormsMain v-if="get_dialogMain.type === 'process'"
              :formCreate="form" :on-success="saveProcess" :on-cancel="closeDialog" :model="main" />
            <FormsMainGral v-if="get_dialogMain.type === 'generalList'"
              titleButton='Agregar' :formCreate="form" :on-success="addInsumo" :model="main" />
            <DataTable v-if="table.showViewtable" :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-card-text>
          <v-card-actions v-if="table.showViewtable">
            <v-layout justify-end>
                <v-btn color="error darken-1" depressed outlined @click="closeDialog" class="mr-3"> Cancelar </v-btn>
                <v-btn color="success darken-1" depressed outlined @click="addInsumo()" class="mr-3">Guardar</v-btn>
            </v-layout>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import FormsMain from '@/components/forms/formsMain'
import FormsMainGral from '@/components/forms/formsMainGral'
import DataTable from '@/components/dataTableMain'
export default {
  name: 'dialogMain',
  props: ['model', 'params'],
  data: () => ({
    table: {
      showViewtable: false,
      header: {
        options: [],
        titles: [
          { text: 'Inventario', value: 'nombre', class: 'black--text' },
          { text: 'Cantidad', value: 'cantidad', class: 'black--text' },
          { text: 'Unidad', value: 'unidad', class: 'black--text' }
        ],
        loading: false
      },
      body: { data: [] },
      footer: { paging: true }
    },
    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    detail: {},
    main: {},
    item: {}
  }),
  components: {
    FormsMain,
    FormsMainGral,
    DataTable
  },
  mounted () {
    this.user = this.$cookies.get('user')
    if (this.params.tableShow) this.table.showViewtable = true
    if (this.get_dialogMain.type === 'process') {
      if (this.model.action) {
        this.form = this.model.body
        return
      }
      this.getFormDataUrl('insumos.options')
    } else if (this.get_dialogMain.type === 'generalList') {
      this.form = { fields: this.params.form }
    }
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapActions(['getFormServicesAction', 'urlGetServiceActionTwo', 'postExecuteAction']),
    getFormDataUrl (url) {
      const router = this.get_urls[url]
      this.getFormServicesAction({ url: router, params: '/2' })
    },
    saveInsumo (model) {
      model.empleado = this.user.empleado_id
      model.departamento = this.user.departamento_id
      model.tipo_actividad = 2
      if (this.get_dialogMain.type !== 'create') {
        model.id = this.model.item.id
      }
      // console.log('model', model)
      const router = this.get_urls['insumos.execute']
      this.postExecuteAction({ url: router, data: model })
    },
    addInsumo (model) {
      this.detail.push(model)
    },
    saveProcess (model) {
      if (this.model.item) {
        model.id = this.model.item.id
      }
      const router = this.get_urls['insumos.execute']
      this.postExecuteAction({ url: router, data: model })
    },
    saveGral (model) {
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_OBJECT_UPDATE', 'CLEAR_OBJECTS_MODEL']),
    closeDialog () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_options', 'get_model', 'get_objectTwo'])
  },
  watch: {
    get_options (vals) {
      if (vals) {
        this.form = vals
      }
    },
    get_objectTwo (val) {
      if (val) {
        this.item.nombre = val.descripcion.nombre
        this.table.body.data.push(this.item)
        this.item = {}
        this.detail = {}
      }
    },
    get_model (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente !!'
      })
      this.SET_DATA_OBJECT_UPDATE(val)
      this.CLEAR_OBJECTS_MODEL()
      this.closeDialog()
    }
  }
}
</script>
<style></style>
